import { defineSemanticTokens } from '@chakra-ui/react/styled-system';

const semanticColors = defineSemanticTokens.colors({
  // sys
  'sys/fg/base': { value: { _light: '{colors.neutral.10}', _dark: '{colors.neutral-dark.10}' } },
  'sys/fg/primary': { value: { _light: '{colors.purple.10}', _dark: '{colors.neutral-dark.10}' } },
  'sys/fg/secondary': { value: { _light: '{colors.neutral.40}', _dark: '{colors.neutral-dark.40}' } },
  'sys/fg/tertiary': { value: { _light: '{colors.neutral.60}', _dark: '{colors.neutral-dark.60}' } },
  'sys/fg/subtle': { value: { _light: '{colors.neutral.70}', _dark: '{colors.neutral-dark.70}' } },
  'sys/fg/minimal': { value: { _light: '{colors.neutral.80}', _dark: '{colors.neutral-dark.80}' } },
  'sys/fg/positive': { value: { _light: '{colors.green.50}', _dark: '{colors.green.60}' } },
  'sys/fg/negative': { value: { _light: '{colors.red.50}', _dark: '{colors.red.60}' } },
  'sys/fg/on-color': { value: { _light: '{colors.neutral.100}' } },
  'sys/fg/on-contrast': { value: { _light: '{colors.neutral.95}', _dark: '{colors.neutral-dark.95}' } },
  'sys/fg/on-disabled': { value: { _light: '{colors.neutral.70}', _dark: '{colors.neutral-dark.70}' } },
  'sys/fg/disabled': { value: { _light: '{colors.neutral.80}', _dark: '{colors.neutral-dark.80}' } },
  'sys/fg/warning': { value: { _light: '{colors.yellow.60}', _dark: '{colors.yellow.80}' } },
  'sys/bg/surface': { value: { _light: '{colors.neutral.100}', _dark: '{colors.neutral-dark.100}' } },
  'sys/bg/contrast': { value: { _light: '{colors.neutral.10}', _dark: '{colors.neutral-dark.10}' } },
  'sys/bg/moderate': { value: { _light: '{colors.neutral.90}', _dark: '{colors.neutral-dark.90}' } },
  'sys/bg/subtle': { value: { _light: '{colors.neutral.93}', _dark: '{colors.neutral-dark.93}' } },
  'sys/bg/minimal': { value: { _light: '{colors.neutral.95}', _dark: '{colors.neutral-dark.95}' } },
  'sys/bg/disabled': { value: { _light: '{colors.neutral.95}', _dark: '{colors.neutral-dark.95}' } },
  'sys/bg/transparent': { value: { _light: 'rgba(255, 255, 255, 0)' } },
  'sys/border/minimal': { value: { _light: '{colors.neutral.93}', _dark: '{colors.neutral-dark.90}' } },
  'sys/border/subtle': { value: { _light: '{colors.neutral.90}', _dark: '{colors.neutral-dark.80}' } },
  'sys/border/strong': { value: { _light: '{colors.neutral.80}', _dark: '{colors.neutral-dark.70}' } },
  'sys/border/emphasized': { value: { _light: '{colors.neutral.70}', _dark: '{colors.neutral-dark.60}' } },
  'sys/border/critical': { value: { _light: '{colors.red.50}', _dark: '{colors.red.60}' } },
  'sys/border/inverse': { value: { _light: '{colors.neutral.100}', _dark: '{colors.neutral-dark.100}' } },
  'sys/border/on-contrast': { value: { _light: '{colors.neutral.95}', _dark: '{colors.neutral-dark.93}' } },
  'sys/border/disabled': { value: { _light: '{colors.neutral.90}', _dark: '{colors.neutral-dark.80}' } },
  'sys/primary/base': { value: { _light: '{colors.purple.40}', _dark: '{colors.purple.30}' } },
  'sys/primary/dark': { value: { _light: '{colors.purple.20}' } },
  'sys/primary/emphasized': { value: { _light: '{colors.purple.30}', _dark: '{colors.purple.40}' } },
  'sys/primary/contrast': { value: { _light: '{colors.purple.10}' } },
  'sys/primary/muted': { value: { _light: '{colors.purple.80}' } },
  'sys/primary/subtle': { value: { _light: '{colors.purple.93}' } },
  'sys/primary/disabled': { value: { _light: '{colors.neutral.90}', _dark: '{colors.neutral-dark.90}' } },
  'sys/primary-danger/base': { value: { _light: '{colors.red.50}', _dark: '{colors.red.60}' } },
  'sys/primary-danger/dark': { value: { _light: '{colors.red.20}' } },
  'sys/primary-danger/strong': { value: { _light: '{colors.red.40}', _dark: '{colors.red.50}' } },
  'sys/primary-danger/bold': { value: { _light: '{colors.red.60}' } },
  'sys/primary-danger/muted': { value: { _light: '{colors.red.80}' } },
  'sys/primary-danger/moderate': { value: { _light: '{colors.red.90}' } },
  'sys/primary-danger/subtle': { value: { _light: '{colors.red.93}' } },
  'sys/primary-danger/minimal': { value: { _light: '{colors.red.95}' } },
  'sys/fixed/icon/primary': { value: { _light: '{colors.purple.10}' } },
  'sys/fixed/icon/warning': { value: { _light: '{colors.yellow.80}' } },

  // color
  'color/purple/base': { value: { _light: '{colors.purple.50}', _dark: '{colors.purple.70}' } },
  'color/purple/strong': { value: { _light: '{colors.purple.40}', _dark: '{colors.purple.80}' } },
  'color/purple/bold': { value: { _light: '{colors.purple.60}' } },
  'color/purple/highlight': { value: { _light: '{colors.purple.70}', _dark: '{colors.purple.50}' } },
  'color/purple/muted': { value: { _light: '{colors.purple.80}', _dark: '{colors.purple.40}' } },
  'color/purple/moderate': { value: { _light: '{colors.purple.90}', _dark: '{colors.purple.30}' } },
  'color/purple/subtle': { value: { _light: '{colors.purple.93}', _dark: '{colors.purple.20}' } },
  'color/purple/minimal': { value: { _light: '{colors.purple.95}', _dark: '{colors.purple.10}' } },
  'color/indigo/base': { value: { _light: '{colors.indigo.50}', _dark: '{colors.indigo.70}' } },
  'color/indigo/dark': { value: { _light: '{colors.indigo.20}', _dark: '{colors.indigo.93}' } },
  'color/indigo/emphasized': { value: { _light: '{colors.indigo.30}', _dark: '{colors.indigo.90}' } },
  'color/indigo/strong': { value: { _light: '{colors.indigo.40}', _dark: '{colors.indigo.80}' } },
  'color/indigo/bold': { value: { _light: '{colors.indigo.60}' } },
  'color/indigo/muted': { value: { _light: '{colors.indigo.80}', _dark: '{colors.indigo.40}' } },
  'color/indigo/moderate': { value: { _light: '{colors.indigo.90}', _dark: '{colors.indigo.30}' } },
  'color/indigo/subtle': { value: { _light: '{colors.indigo.93}', _dark: '{colors.indigo.20}' } },
  'color/indigo/minimal': { value: { _light: '{colors.indigo.95}', _dark: '{colors.indigo.10}' } },
  'color/blue/base': { value: { _light: '{colors.blue.50}', _dark: '{colors.blue.70}' } },
  'color/blue/strong': { value: { _light: '{colors.blue.40}', _dark: '{colors.blue.80}' } },
  'color/blue/bold': { value: { _light: '{colors.blue.60}' } },
  'color/blue/muted': { value: { _light: '{colors.blue.80}', _dark: '{colors.blue.40}' } },
  'color/blue/moderate': { value: { _light: '{colors.blue.90}', _dark: '{colors.blue.30}' } },
  'color/blue/subtle': { value: { _light: '{colors.blue.93}', _dark: '{colors.blue.20}' } },
  'color/blue/minimal': { value: { _light: '{colors.blue.95}', _dark: '{colors.blue.10}' } },
  'color/green/base': { value: { _light: '{colors.green.50}', _dark: '{colors.green.70}' } },
  'color/green/strong': { value: { _light: '{colors.green.40}', _dark: '{colors.green.80}' } },
  'color/green/bold': { value: { _light: '{colors.green.60}' } },
  'color/green/muted': { value: { _light: '{colors.green.80}', _dark: '{colors.green.40}' } },
  'color/green/moderate': { value: { _light: '{colors.green.90}', _dark: '{colors.green.30}' } },
  'color/green/subtle': { value: { _light: '{colors.green.93}', _dark: '{colors.green.20}' } },
  'color/green/minimal': { value: { _light: '{colors.green.95}', _dark: '{colors.green.10}' } },
  'color/yellow/base': { value: { _light: '{colors.yellow.50}', _dark: '{colors.yellow.70}' } },
  'color/yellow/strong': { value: { _light: '{colors.yellow.40}', _dark: '{colors.yellow.80}' } },
  'color/yellow/bold': { value: { _light: '{colors.yellow.60}' } },
  'color/yellow/muted': { value: { _light: '{colors.yellow.80}', _dark: '{colors.yellow.40}' } },
  'color/yellow/moderate': { value: { _light: '{colors.yellow.90}', _dark: '{colors.yellow.30}' } },
  'color/yellow/subtle': { value: { _light: '{colors.yellow.93}', _dark: '{colors.yellow.20}' } },
  'color/yellow/minimal': { value: { _light: '{colors.yellow.95}', _dark: '{colors.yellow.10}' } },
  'color/red/base': { value: { _light: '{colors.red.50}', _dark: '{colors.red.70}' } },
  'color/red/dark': { value: { _light: '{colors.red.20}', _dark: '{colors.red.93}' } },
  'color/red/strong': { value: { _light: '{colors.red.40}', _dark: '{colors.red.80}' } },
  'color/red/bold': { value: { _light: '{colors.red.60}' } },
  'color/red/muted': { value: { _light: '{colors.red.80}', _dark: '{colors.red.40}' } },
  'color/red/moderate': { value: { _light: '{colors.red.90}', _dark: '{colors.red.30}' } },
  'color/red/subtle': { value: { _light: '{colors.red.93}', _dark: '{colors.red.20}' } },
  'color/red/minimal': { value: { _light: '{colors.red.95}', _dark: '{colors.red.10}' } },
  'color/neutral/base': { value: { _light: '{colors.neutral.50}', _dark: '{colors.neutral-dark.50}' } },
  'color/neutral/strong': { value: { _light: '{colors.neutral.40}', _dark: '{colors.neutral-dark.40}' } },
  'color/neutral/bold': { value: { _light: '{colors.neutral.60}', _dark: '{colors.neutral-dark.60}' } },
  'color/neutral/muted': { value: { _light: '{colors.neutral.80}', _dark: '{colors.neutral-dark.80}' } },
  'color/neutral/moderate': { value: { _light: '{colors.neutral.90}', _dark: '{colors.neutral-dark.90}' } },
  'color/neutral/subtle': { value: { _light: '{colors.neutral.93}', _dark: '{colors.neutral-dark.93}' } },
  'color/neutral/minimal': { value: { _light: '{colors.neutral.95}', _dark: '{colors.neutral-dark.95}' } },
  'color/orange/base': { value: { _light: '{colors.orange.50}', _dark: '{colors.orange.70}' } },
  'color/orange/strong': { value: { _light: '{colors.orange.40}', _dark: '{colors.orange.80}' } },
  'color/orange/bold': { value: { _light: '{colors.orange.60}' } },
  'color/orange/muted': { value: { _light: '{colors.orange.80}', _dark: '{colors.orange.40}' } },
  'color/orange/moderate': { value: { _light: '{colors.orange.90}', _dark: '{colors.orange.30}' } },
  'color/orange/subtle': { value: { _light: '{colors.orange.93}', _dark: '{colors.orange.20}' } },
  'color/orange/minimal': { value: { _light: '{colors.orange.95}', _dark: '{colors.orange.10}' } },
  'color/turquoise/base': { value: { _light: '{colors.turquoise.50}', _dark: '{colors.turquoise.70}' } },
  'color/turquoise/dark': { value: { _light: '{colors.turquoise.20}', _dark: '{colors.turquoise.93}' } },
  'color/turquoise/emphasized': { value: { _light: '{colors.turquoise.30}', _dark: '{colors.turquoise.90}' } },
  'color/turquoise/strong': { value: { _light: '{colors.turquoise.40}', _dark: '{colors.turquoise.80}' } },
  'color/turquoise/bold': { value: { _light: '{colors.turquoise.60}' } },
  'color/turquoise/muted': { value: { _light: '{colors.turquoise.80}', _dark: '{colors.turquoise.40}' } },
  'color/turquoise/moderate': { value: { _light: '{colors.turquoise.90}', _dark: '{colors.turquoise.30}' } },
  'color/turquoise/subtle': { value: { _light: '{colors.turquoise.93}', _dark: '{colors.turquoise.20}' } },
  'color/turquoise/minimal': { value: { _light: '{colors.turquoise.95}', _dark: '{colors.turquoise.10}' } },
  'color/transparent': { value: { _light: '{colors.sys/bg/transparent}' } },
  'color/white/10': { value: { _light: '{colors.white.10}' } },
  'color/white/15': { value: { _light: '{colors.white.15}' } },
  'color/white/20': { value: { _light: '{colors.white.20}' } },
  'color/white/30': { value: { _light: '{colors.white.30}' } },
  'color/white/40': { value: { _light: '{colors.white.40}' } },
  'color/white/50': { value: { _light: '{colors.white.50}' } },
  'color/white/60': { value: { _light: '{colors.white.60}' } },
  'color/white/70': { value: { _light: '{colors.white.70}' } },
  'color/white/80': { value: { _light: '{colors.white.80}' } },
  'color/white/85': { value: { _light: '{colors.white.85}' } },
  'color/white/90': { value: { _light: '{colors.white.90}' } },
  'color/white/100': { value: { _light: '{colors.white.100}' } },

  // gradient/ai
  'gradient/ai/background/base': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/base} 0%, {colors.color/indigo/base} 50%, {colors.color/blue/base} 100%)',
    },
  },
  'gradient/ai/background/bold': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/bold} 0%, {colors.color/indigo/bold} 50%, {colors.color/blue/bold} 100%)',
    },
  },
  'gradient/ai/background/muted': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/muted} 0%, {colors.color/indigo/muted} 50%, {colors.color/blue/muted} 100%)',
    },
  },
  'gradient/ai/background/minimal': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/minimal} 0%, {colors.color/indigo/minimal} 50%, {colors.color/blue/minimal} 100%)',
    },
  },
  'gradient/ai/background/subtle': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/subtle} 0%, {colors.color/indigo/subtle} 50%, {colors.color/blue/subtle} 100%)',
    },
  },
  'gradient/ai/background/moderate': {
    value: {
      base: 'linear-gradient(90deg, {colors.color/purple/moderate} 0%, {colors.color/indigo/moderate} 50%, {colors.color/blue/moderate} 100%)',
    },
  },
  'gradient/ai/background/minimal-vertical': {
    value: {
      base: 'linear-gradient(180deg, {colors.color/purple/minimal} 0%, {colors.color/indigo/minimal} 50%, {colors.color/blue/minimal} 100%)',
    },
  },
  'gradient/ai/background/surface': {
    value: { base: 'linear-gradient(180deg, {colors.sys/bg/surface} 0%, {colors.color/indigo/minimal} 100%)' },
  },
  'gradient/ai/border/minimal': {
    value: {
      base: 'linear-gradient(135deg, {colors.color/purple/minimal} 0%, {colors.color/indigo/minimal} 50%, {colors.color/blue/minimal} 100%)',
    },
  },
  'gradient/ai/border/subtle': {
    value: {
      base: 'linear-gradient(135deg, {colors.color/purple/subtle} 0%, {colors.color/indigo/subtle} 50%, {colors.color/blue/subtle} 100%)',
    },
  },
  'gradient/ai/border/strong': {
    value: {
      base: 'linear-gradient(135deg, {colors.color/purple/muted} 0%, {colors.color/indigo/muted} 50%, {colors.color/blue/muted} 100%)',
    },
  },
  'gradient/overflow/bottom': {
    value: {
      base: 'linear-gradient(180deg, color-mix(in srgb, {colors.sys/bg/surface} 0%, transparent) 0%, {colors.sys/bg/surface} 100%)',
    },
  },
  'gradient/overflow/right': {
    value: {
      base: 'linear-gradient(90deg, color-mix(in srgb, {colors.sys/bg/surface} 0%, transparent) 0%, {colors.sys/bg/surface} 100%)',
    },
  },
  'gradient/video/bg': {
    value: { base: 'linear-gradient(90deg, {colors.sys/primary/dark} 0%, {colors.sys/primary/base} 100%)' },
  },

  // background
  'background/primary': { value: { base: '{colors.sys/bg/surface}' } },
  'background/secondary': { value: { base: '{colors.sys/bg/minimal}' } },
  'background/tertiary': { value: { base: '{colors.sys/bg/subtle}' } },
  'background/hover': { value: { base: '{colors.sys/bg/subtle}' } },
  'background/active': { value: { base: '{colors.sys/bg/moderate}' } },
  'background/selected': { value: { base: '{colors.color/purple/minimal}' } },
  'background/selected-active': { value: { base: '{colors.color/purple/moderate}' } },
  'background/selected-hover': { value: { base: '{colors.color/purple/subtle}' } },
  'background/contrast': { value: { base: '{colors.sys/bg/contrast}' } },
  'background/disabled': { value: { base: '{colors.sys/bg/disabled}' } },

  // border
  'border/regular': { value: { base: '{colors.sys/border/subtle}' } },
  'border/minimal': { value: { base: '{colors.sys/border/minimal}' } },
  'border/strong': { value: { base: '{colors.sys/border/strong}' } },
  'border/hover': { value: { base: '{colors.sys/border/emphasized}' } },
  'border/focus': { value: { base: '{colors.color/purple/highlight}' } },
  'border/selected': { value: { base: '{colors.color/purple/base}' } },
  'border/error': { value: { base: '{colors.sys/border/critical}' } },
  'border/inverse': { value: { base: '{colors.sys/border/inverse}' } },
  'border/on-contrast': { value: { base: '{colors.sys/border/on-contrast}' } },
  'border/disabled': { value: { base: '{colors.sys/border/disabled}' } },

  // text
  'text/primary': { value: { base: '{colors.sys/fg/primary}' } },
  'text/secondary': { value: { base: '{colors.sys/fg/secondary}' } },
  'text/tertiary': { value: { base: '{colors.sys/fg/tertiary}' } },
  'text/body': { value: { base: '{colors.sys/fg/base}' } },
  'text/helper': { value: { base: '{colors.sys/fg/secondary}' } },
  'text/link': { value: { base: '{colors.color/purple/base}' } },
  'text/link-hover': { value: { base: '{colors.color/purple/strong}' } },
  'text/selected': { value: { base: '{colors.color/purple/base}' } },
  'text/positive': { value: { base: '{colors.sys/fg/positive}' } },
  'text/negative': { value: { base: '{colors.sys/fg/negative}' } },
  'text/on-color': { value: { base: '{colors.sys/fg/on-color}' } },
  'text/on-contrast': { value: { base: '{colors.sys/fg/on-contrast}' } },
  'text/on-disabled': { value: { base: '{colors.sys/fg/on-disabled}' } },
  'text/disabled': { value: { base: '{colors.sys/fg/disabled}' } },

  // icon
  'icon/primary': { value: { base: '{colors.sys/fg/primary}' } },
  'icon/secondary': { value: { base: '{colors.sys/fg/secondary}' } },
  'icon/tertiary': { value: { base: '{colors.sys/fg/tertiary}' } },
  'icon/interactive': { value: { base: '{colors.color/purple/base}' } },
  'icon/interactive-hover': { value: { base: '{colors.color/purple/strong}' } },
  'icon/positive': { value: { base: '{colors.sys/fg/positive}' } },
  'icon/negative': { value: { base: '{colors.sys/fg/negative}' } },
  'icon/on-color': { value: { base: '{colors.sys/fg/on-color}' } },
  'icon/on-contrast': { value: { base: '{colors.sys/fg/on-contrast}' } },
  'icon/on-disabled': { value: { base: '{colors.sys/fg/on-disabled}' } },
  'icon/disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'icon/warning': { value: { base: '{colors.sys/fg/warning}' } },

  // button
  'button/primary/bg': { value: { base: '{colors.sys/primary/base}' } },
  'button/primary/bg-hover': { value: { base: '{colors.sys/primary/emphasized}' } },
  'button/primary/bg-active': { value: { base: '{colors.sys/primary/contrast}' } },
  'button/primary/bg-disabled': { value: { base: '{colors.sys/primary/disabled}' } },
  'button/primary/fg': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/primary/fg-hover': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/primary/fg-active': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/primary/fg-disabled': { value: { base: '{colors.sys/fg/on-disabled}' } },
  'button/secondary/bg': { value: { base: '{colors.sys/bg/surface}' } },
  'button/secondary/bg-hover': { value: { base: '{colors.sys/bg/subtle}' } },
  'button/secondary/bg-active': { value: { base: '{colors.sys/bg/moderate}' } },
  'button/secondary/bg-disabled': { value: { base: '{colors.sys/bg/minimal}' } },
  'button/secondary/text': { value: { base: '{colors.sys/fg/primary}' } },
  'button/secondary/text-hover': { value: { base: '{colors.sys/fg/primary}' } },
  'button/secondary/text-active': { value: { base: '{colors.sys/fg/primary}' } },
  'button/secondary/text-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/secondary/icon': { value: { base: '{colors.sys/fg/secondary}' } },
  'button/secondary/icon-hover': { value: { base: '{colors.sys/fg/primary}' } },
  'button/secondary/icon-active': { value: { base: '{colors.sys/fg/primary}' } },
  'button/secondary/icon-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/secondary/border': { value: { base: '{colors.sys/border/strong}' } },
  'button/secondary/border-hover': { value: { base: '{colors.sys/border/emphasized}' } },
  'button/secondary/border-active': { value: { base: '{colors.sys/border/emphasized}' } },
  'button/secondary/border-disabled': { value: { base: '{colors.sys/border/disabled}' } },
  'button/tertiary/bg': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/tertiary/bg-hover': { value: { base: '{colors.sys/bg/subtle}' } },
  'button/tertiary/bg-active': { value: { base: '{colors.sys/bg/moderate}' } },
  'button/tertiary/bg-disabled': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/tertiary/fg': { value: { base: '{colors.color/purple/base}' } },
  'button/tertiary/fg-hover': { value: { base: '{colors.color/purple/strong}' } },
  'button/tertiary/fg-active': { value: { base: '{colors.sys/fg/primary}' } },
  'button/tertiary/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/danger-primary/bg': { value: { base: '{colors.sys/primary-danger/base}' } },
  'button/danger-primary/bg-hover': { value: { base: '{colors.sys/primary-danger/strong}' } },
  'button/danger-primary/bg-active': { value: { base: '{colors.sys/primary-danger/dark}' } },
  'button/danger-primary/bg-disabled': { value: { base: '{colors.sys/primary/disabled}' } },
  'button/danger-primary/fg': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/danger-primary/fg-hover': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/danger-primary/fg-active': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/danger-primary/fg-disabled': { value: { base: '{colors.sys/fg/on-disabled}' } },
  'button/danger-secondary/bg': { value: { base: '{colors.sys/bg/surface}' } },
  'button/danger-secondary/bg-hover': { value: { base: '{colors.color/red/minimal}' } },
  'button/danger-secondary/bg-active': { value: { base: '{colors.color/red/moderate}' } },
  'button/danger-secondary/bg-disabled': { value: { base: '{colors.sys/bg/minimal}' } },
  'button/danger-secondary/fg': { value: { base: '{colors.color/red/base}' } },
  'button/danger-secondary/fg-hover': { value: { base: '{colors.color/red/base}' } },
  'button/danger-secondary/fg-active': { value: { base: '{colors.color/red/strong}' } },
  'button/danger-secondary/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/danger-secondary/border': { value: { base: '{colors.color/red/muted}' } },
  'button/danger-secondary/border-hover': { value: { base: '{colors.color/red/muted}' } },
  'button/danger-secondary/border-active': { value: { base: '{colors.color/red/base}' } },
  'button/danger-secondary/border-disabled': { value: { base: '{colors.sys/border/disabled}' } },
  'button/danger-tertiary/bg': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/danger-tertiary/bg-hover': { value: { base: '{colors.color/red/minimal}' } },
  'button/danger-tertiary/bg-active': { value: { base: '{colors.color/red/moderate}' } },
  'button/danger-tertiary/bg-disabled': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/danger-tertiary/fg': { value: { base: '{colors.color/red/base}' } },
  'button/danger-tertiary/fg-hover': { value: { base: '{colors.color/red/base}' } },
  'button/danger-tertiary/fg-active': { value: { base: '{colors.color/red/strong}' } },
  'button/danger-tertiary/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/ai-primary/bg': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-primary/bg-hover': { value: { base: '{colors.color/indigo/emphasized}' } },
  'button/ai-primary/bg-active': { value: { base: '{colors.color/indigo/dark}' } },
  'button/ai-primary/bg-disabled': { value: { base: '{colors.sys/primary/disabled}' } },
  'button/ai-primary/fg': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/ai-primary/fg-hover': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/ai-primary/fg-active': { value: { base: '{colors.sys/fg/on-color}' } },
  'button/ai-primary/fg-disabled': { value: { base: '{colors.sys/fg/on-disabled}' } },
  'button/ai-secondary/bg': { value: { base: '{colors.sys/bg/surface}' } },
  'button/ai-secondary/bg-hover': { value: { base: '{colors.color/indigo/minimal}' } },
  'button/ai-secondary/bg-active': { value: { base: '{colors.color/indigo/moderate}' } },
  'button/ai-secondary/bg-disabled': { value: { base: '{colors.sys/bg/minimal}' } },
  'button/ai-secondary/fg': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-secondary/fg-hover': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-secondary/fg-active': { value: { base: '{colors.color/indigo/strong}' } },
  'button/ai-secondary/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/ai-secondary/border': { value: { base: '{colors.color/indigo/muted}' } },
  'button/ai-secondary/border-hover': { value: { base: '{colors.color/indigo/muted}' } },
  'button/ai-secondary/border-active': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-secondary/border-disabled': { value: { base: '{colors.sys/border/disabled}' } },
  'button/ai-tertiary/bg': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/ai-tertiary/bg-hover': { value: { base: '{colors.color/indigo/minimal}' } },
  'button/ai-tertiary/bg-active': { value: { base: '{colors.color/indigo/moderate}' } },
  'button/ai-tertiary/bg-disabled': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/ai-tertiary/fg': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-tertiary/fg-hover': { value: { base: '{colors.color/indigo/base}' } },
  'button/ai-tertiary/fg-active': { value: { base: '{colors.color/indigo/strong}' } },
  'button/ai-tertiary/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/control/bg': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/control/bg-hover': { value: { base: '{colors.sys/bg/subtle}' } },
  'button/control/bg-active': { value: { base: '{colors.sys/bg/moderate}' } },
  'button/control/bg-disabled': { value: { base: '{colors.sys/bg/minimal}' } },
  'button/control/fg': { value: { base: '{colors.sys/fg/secondary}' } },
  'button/control/fg-hover': { value: { base: '{colors.sys/fg/primary}' } },
  'button/control/fg-active': { value: { base: '{colors.sys/fg/primary}' } },
  'button/control/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },
  'button/control-danger/bg': { value: { base: '{colors.sys/bg/transparent}' } },
  'button/control-danger/bg-hover': { value: { base: '{colors.color/red/minimal}' } },
  'button/control-danger/bg-active': { value: { base: '{colors.color/red/moderate}' } },
  'button/control-danger/bg-disabled': { value: { base: '{colors.sys/bg/minimal}' } },
  'button/control-danger/fg': { value: { base: '{colors.color/red/base}' } },
  'button/control-danger/fg-hover': { value: { base: '{colors.color/red/base}' } },
  'button/control-danger/fg-active': { value: { base: '{colors.color/red/strong}' } },
  'button/control-danger/fg-disabled': { value: { base: '{colors.sys/fg/disabled}' } },

  // sys/ui/header
  'sys/ui/header/bg': { value: { base: '{colors.purple.30}' } },
  'sys/ui/header/control/bg': { value: { base: '{colors.color/transparent}' } },
  'sys/ui/header/control/bg-hover': { value: { base: '{colors.color/white/10}' } },
  'sys/ui/header/control/bg-active': { value: { base: '{colors.color/white/20}' } },
  'sys/ui/header/control/bg-selected': { value: { base: '{colors.color/white/10}' } },
  'sys/ui/header/control/bg-selected-hover': { value: { base: '{colors.color/white/20}' } },
  'sys/ui/header/control/indicator': { value: { base: '{colors.color/white/80}' } },
  'sys/ui/header/button/primary/bg': { value: { base: '{colors.color/white/100}' } },
  'sys/ui/header/button/primary/bg-hover': { value: { base: '{colors.purple.95}' } },
  'sys/ui/header/button/primary/bg-active': { value: { base: '{colors.purple.95}' } },
  'sys/ui/header/button/primary/bg-disabled': { value: { base: '{colors.color/white/50}' } },
  'sys/ui/header/button/primary/fg': { value: { base: '{colors.purple.30}' } },
  'sys/ui/header/button/primary/fg-disabled': { value: { base: '{colors.neutral.90}' } },
  'sys/ui/header/button/secondary/bg': { value: { base: '{colors.color/white/10}' } },
  'sys/ui/header/button/secondary/bg-hover': { value: { base: '{colors.purple.20}' } },
  'sys/ui/header/button/secondary/bg-active': { value: { base: '{colors.purple.20}' } },
  'sys/ui/header/button/secondary/bg-disabled': { value: { base: '{colors.color/transparent}' } },
  'sys/ui/header/button/secondary/fg': { value: { base: '{colors.color/white/100}' } },
  'sys/ui/header/button/secondary/fg-disabled': { value: { base: '{colors.color/white/50}' } },
  'sys/ui/header/button/secondary/border': { value: { base: '{colors.color/white/50}' } },
  'sys/ui/header/button/secondary/border-disabled': { value: { base: '{colors.color/white/30}' } },
  'sys/ui/header/button/tertiary/bg': { value: { base: '{colors.color/transparent}' } },
  'sys/ui/header/button/tertiary/bg-hover': { value: { base: '{colors.color/white/10}' } },
  'sys/ui/header/button/tertiary/bg-active': { value: { base: '{colors.color/white/20}' } },
  'sys/ui/header/button/tertiary/bg-disabled': { value: { base: '{colors.color/transparent}' } },
  'sys/ui/header/button/tertiary/fg': { value: { base: '{colors.color/white/100}' } },
  'sys/ui/header/button/tertiary/fg-disabled': { value: { base: '{colors.color/white/50}' } },
  'sys/ui/header/badge/red': { value: { base: '{colors.red.60}' } },
  'sys/ui/header/badge/indigo': { value: { base: '{colors.indigo.90}' } },

  // sys/ui/sidenav
  'sys/ui/sidenav/bg': { value: { base: '{colors.purple.10}' } },
  'sys/ui/sidenav/item/bg': { value: { base: '{colors.color/transparent}' } },
  'sys/ui/sidenav/item/bg-hover': { value: { base: '{colors.color/white/10}' } },
  'sys/ui/sidenav/item/bg-active': { value: { base: '{colors.color/white/20}' } },
  'sys/ui/sidenav/item/bg-selected': { value: { base: '{colors.color/white/20}' } },
  'sys/ui/sidenav/item/fg': { value: { base: '{colors.color/white/80}' } },
  'sys/ui/sidenav/item/fg-hover': { value: { base: '{colors.color/white/100}' } },
  'sys/ui/sidenav/item/fg-active': { value: { base: '{colors.color/white/100}' } },
  'sys/ui/sidenav/item/indicator': { value: { base: '{colors.color/white/80}' } },
  'sys/ui/sidenav/badge/green': { value: { base: '{colors.green.60}' } },
  'sys/ui/sidenav/badge/red': { value: { base: '{colors.red.60}' } },
  'sys/ui/sidenav/badge/neutral': { value: { base: '{colors.neutral.40}' } },

  // input
  'input/text/label': { value: { base: '{colors.sys/fg/primary}' } },
  'input/text/inputValue': { value: { base: '{colors.sys/fg/base}' } },
  'input/text/placeholder': { value: { base: '{colors.sys/fg/subtle}' } },
  'input/text/error': { value: { base: '{colors.sys/fg/negative}' } },
  'input/checkbox/selection': { value: { base: '{colors.interactive/base}' } },
  'input/checkbox/selection-disabled': { value: { base: '{colors.interactive/disabled}' } },
  'input/switch/on/track': { value: { base: '{colors.color/green/bold}' } },
  'input/switch/on/track-disabled': {
    value: { base: 'color-mix(in srgb, {colors.color/green/bold} 50%, transparent)' },
  },
  'input/switch/on/thumb': { value: { base: '{colors.sys/fg/on-color}' } },
  'input/switch/on/thumb-disabled': { value: { base: '{colors.sys/fg/on-color}' } },
  'input/switch/off/track': { value: { base: '{colors.color/neutral/bold}' } },
  'input/switch/off/track-disabled': {
    value: { base: 'color-mix(in srgb, {colors.color/neutral/bold} 50%, transparent)' },
  },
  'input/switch/off/thumb': { value: { base: '{colors.sys/fg/on-color}' } },
  'input/switch/off/thumb-disabled': { value: { base: '{colors.sys/fg/on-color}' } },

  // interactive
  'interactive/base': { value: { base: '{colors.color/purple/base}' } },
  'interactive/bold': { value: { base: '{colors.color/purple/bold}' } },
  'interactive/highlight': { value: { base: '{colors.color/purple/highlight}' } },
  'interactive/muted': { value: { base: '{colors.color/purple/muted}' } },
  'interactive/moderate': { value: { base: '{colors.color/purple/moderate}' } },
  'interactive/subtle': { value: { base: '{colors.color/purple/subtle}' } },
  'interactive/minimal': { value: { base: '{colors.color/purple/minimal}' } },
  'interactive/disabled': { value: { base: '{colors.color/neutral/moderate}' } },

  // status
  'status/info/bg': { value: { base: '{colors.color/blue/minimal}' } },
  'status/info/bg-hover': { value: { base: '{colors.color/blue/subtle}' } },
  'status/info/bg-active': { value: { base: '{colors.color/blue/moderate}' } },
  'status/info/border': { value: { base: '{colors.color/blue/muted}' } },
  'status/info/icon': { value: { base: '{colors.color/blue/strong}' } },
  'status/info/text': { value: { base: '{colors.color/blue/strong}' } },
  'status/success/bg': { value: { base: '{colors.color/green/minimal}' } },
  'status/success/bg-hover': { value: { base: '{colors.color/green/subtle}' } },
  'status/success/bg-active': { value: { base: '{colors.color/green/moderate}' } },
  'status/success/border': { value: { base: '{colors.color/green/muted}' } },
  'status/success/icon': { value: { base: '{colors.color/green/strong}' } },
  'status/success/text': { value: { base: '{colors.color/green/strong}' } },
  'status/warning/bg': { value: { base: '{colors.color/yellow/minimal}' } },
  'status/warning/bg-hover': { value: { base: '{colors.color/yellow/subtle}' } },
  'status/warning/bg-active': { value: { base: '{colors.color/yellow/moderate}' } },
  'status/warning/border': { value: { base: '{colors.color/yellow/muted}' } },
  'status/warning/icon': { value: { base: '{colors.color/yellow/strong}' } },
  'status/warning/text': { value: { base: '{colors.color/yellow/strong}' } },
  'status/critical/bg': { value: { base: '{colors.color/red/minimal}' } },
  'status/critical/bg-hover': { value: { base: '{colors.color/red/subtle}' } },
  'status/critical/bg-active': { value: { base: '{colors.color/red/moderate}' } },
  'status/critical/border': { value: { base: '{colors.color/red/muted}' } },
  'status/critical/icon': { value: { base: '{colors.color/red/strong}' } },
  'status/critical/text': { value: { base: '{colors.color/red/strong}' } },
  'status/progress/bg': { value: { base: '{colors.color/purple/minimal}' } },
  'status/progress/bg-hover': { value: { base: '{colors.color/purple/subtle}' } },
  'status/progress/bg-active': { value: { base: '{colors.color/purple/moderate}' } },
  'status/progress/border': { value: { base: '{colors.color/purple/muted}' } },
  'status/progress/icon': { value: { base: '{colors.color/purple/strong}' } },
  'status/progress/text': { value: { base: '{colors.color/purple/strong}' } },
  'status/neutral/bg': { value: { base: '{colors.color/neutral/minimal}' } },
  'status/neutral/bg-hover': { value: { base: '{colors.color/neutral/subtle}' } },
  'status/neutral/bg-active': { value: { base: '{colors.color/neutral/moderate}' } },
  'status/neutral/border': { value: { base: '{colors.color/neutral/muted}' } },
  'status/neutral/icon': { value: { base: '{colors.color/neutral/strong}' } },
  'status/neutral/text': { value: { base: '{colors.color/neutral/strong}' } },
  'status/ai/bg': { value: { base: '{colors.gradient/ai/background/minimal}' } },
  'status/ai/bg-hover': { value: { base: '{colors.color/indigo/subtle}' } },
  'status/ai/bg-active': { value: { base: '{colors.color/indigo/moderate}' } },
  'status/ai/border': {
    value: { base: '{colors.gradient/ai/border/strong}' },
  },
  'status/ai/surface': {
    value: { base: '{colors.status/ai/bg} padding-box, {colors.status/ai/border} border-box' },
  },
  'status/ai/icon': { value: { base: '{colors.color/indigo/strong}' } },
  'status/ai/text': { value: { base: '{colors.color/indigo/strong}' } },

  // utilities
  'utilities/overlay': { value: { base: 'color-mix(in srgb, {colors.neutral.10} 50%, transparent)' } },
  'utilities/overlay-side': {
    value: {
      base: 'linear-gradient(90deg, color-mix(in srgb, {colors.neutral.10} 0%, transparent) 0%, color-mix(in srgb, {colors.neutral.10} 32%, transparent) 100%)',
    },
  },
  'utilities/overlay-light': { value: { base: 'color-mix(in srgb, {colors.neutral.10} 16%, transparent)' } },
  'utilities/overlay-dark': { value: { base: 'color-mix(in srgb, {colors.neutral.10} 80%, transparent)' } },
  'utilities/skeleton': { value: { base: '{colors.sys/bg/subtle}' } },
  'utilities/skeleton-highlight': { value: { base: '{colors.background/primary}' } },
});

export default semanticColors;
